import { stripSvgDimensionLabels } from './drawingDimensionOverlays';

/** Prepare saved drawing SVG for quote preview/PDF */
export function enhanceQuoteDrawingSvg(svgString) {
  if (!svgString || typeof svgString !== 'string') return svgString;
  return svgString;
}

export function enhanceQuoteDrawingSvgElement(svg) {
  stripSvgDimensionLabels(svg);
}
